import { inject } from '@angular/core'
import { Capacitor } from '@capacitor/core'
import { CanMatchFn, Router } from '@angular/router'

export const webOnlyGuard: CanMatchFn = () =>
  Capacitor.isNativePlatform() ? inject(Router).createUrlTree(['/']) : true
